/* import __COLOCATED_TEMPLATE__ from './address-input-field-street1.hbs.js'; */
var _dec, _dec2, _dec3, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tagName } from '@ember-decorators/component';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import Component from '@ember/component';
let AddressInputFieldStreet1 = (_dec = tagName(''), _dec2 = alias('countryAddressDataLocalizer.street1Name'), _dec3 = computed('onAutocompleteItemSelected', 'address.countryCode'), _dec(_class = (_class2 = class AddressInputFieldStreet1 extends Component {
  constructor(...args) {
    super(...args);
    // passed-in
    _defineProperty(this, "address", null);
    _defineProperty(this, "onAutocompleteItemSelected", null);
    _defineProperty(this, "countryAddressDataLocalizer", null);
    _defineProperty(this, "isReadOnly", false);
    _defineProperty(this, "initialValue", null);
    _initializerDefineProperty(this, "street1Name", _descriptor, this);
    _defineProperty(this, "onMarketAutocompleteItemSelected", item => {
      this.onAutocompleteItemSelected(item);
      this.set('initialValue', item?.address.addressLine1);
    });
    _defineProperty(this, "onMarketComboboxInputValueChange", (_prev, value) => {
      this.set('address.addressLine1', value);
    });
  }
  init(...args) {
    super.init(...args);
    this.initialValue = this.address?.addressLine1;
  }
  get shouldUseAutocomplete() {
    return this.onAutocompleteItemSelected !== null && typeof this.onAutocompleteItemSelected === 'function' && this.address?.countryCode !== 'JP';
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "street1Name", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "shouldUseAutocomplete", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "shouldUseAutocomplete"), _class2.prototype), _class2)) || _class);
export { AddressInputFieldStreet1 as default };